import { render } from "./OffcanvasInfo.vue?vue&type=template&id=5e57c6b3&scoped=true"
import script from "./OffcanvasInfo.vue?vue&type=script&lang=js"
export * from "./OffcanvasInfo.vue?vue&type=script&lang=js"

import "./OffcanvasInfo.vue?vue&type=style&index=0&id=5e57c6b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e57c6b3"]])

export default __exports__